﻿import { OrderPlacedDetailsProps } from 'components/secondaryMarket/dlpOrder/sidePanel/orderPlaced/OrderPlacedDetails';
import { connect } from 'react-redux';
import { tradeBlottersOpenDlpProduct } from 'state/blotters/trades/tradesBlotters.actions';
import { makeGetDlpOrderValidationErrors } from 'state/secondaryMarket/dlpOrder/dlpOrder.selectors';
import { secondaryMarketDlpOrderPlacementCloseThunk } from 'state/secondaryMarket/dlpOrder/order/order.thunks';
import { getSecondaryMarketDlpProductIsinFromTab } from 'state/secondaryMarket/referential/dlpProduct/dlpProduct.selectors';
import {
  fromSecondaryMarket,
  getUserPreferencesSecondaryMarketCloseTabWhenOrderPlacedActivated,
} from 'state/selectors';
import { isTradeBlotterVisible } from 'state/selectors/common/router';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
  className?: string;
}>;

type StateProps = Readonly<OrderPlacedDetailsProps> & {
  hasTradeBlotter: boolean;
  closeTabWhenOrderIsPlaced: boolean;
  quantity?: number;
  execTime?: string;
  limit?: number;
};

type DispatchProps = Readonly<{
  onDone: (closeTab?: boolean) => void;
  onViewInTradeBlotter: (isin: string) => void;
}>;

export type OrderPlacedSidePanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const tradeWay = fromSecondaryMarket.dlpOrder.form.getInputFormTradeWay(state, tabId)!;
  const orderId = fromSecondaryMarket.dlpOrder.order.getOrderId(state, tabId)!;
  const isin = getSecondaryMarketDlpProductIsinFromTab(state, tabId)!;
  const orderType = fromSecondaryMarket.dlpOrder.form.getInputFormOrderType(state, tabId);
  const validity = fromSecondaryMarket.dlpOrder.form.getInputFormValidity(state, tabId);
  const getOrderValidationErrors = makeGetDlpOrderValidationErrors();
  const quantity = fromSecondaryMarket.dlpOrder.form.getInputFormQuantity(state, tabId);
  const limit = fromSecondaryMarket.dlpOrder.form.getInputFormLimit(state, tabId);
  const execTime = fromSecondaryMarket.dlpOrder.order.getOrderExecutionTime(state, tabId);
  const getOrderStatus = fromSecondaryMarket.dlpOrder.order.makeGetDlpOrderStatus(getOrderValidationErrors);
  const status = getOrderStatus(state, tabId);

  return {
    orderId,
    tradeWay,
    quantity,
    isin,
    orderType,
    execTime,
    limit,
    validity,
    status,
    hasTradeBlotter: isTradeBlotterVisible(state),
    closeTabWhenOrderIsPlaced: getUserPreferencesSecondaryMarketCloseTabWhenOrderPlacedActivated(state),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onDone: closeTab => {
      dispatch(secondaryMarketDlpOrderPlacementCloseThunk(tabId, closeTab));
    },
    onViewInTradeBlotter: (isin: string) => {
      dispatch(tradeBlottersOpenDlpProduct(isin));
    },
  };
};

export const connectOrderPlacedSidePanel = connect(mapStateToProps, mapDispatchToProps);
